/**
 * A global namespace for `dragleave` event.
 */
const dragleaveEvent = 'dragleave';
export default dragleaveEvent;
